import React from 'react'
import { graphql } from 'gatsby'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import ProductDetail from '../ProductDetail'
import { Wrapper } from '../../Container/Container.style'
import { ProductCarouselContainer } from './ProductCarousel.style'

const ProductCarousel = ({ settings, products, productBackgroundImage }) => (
  <Wrapper className="carousel-wrapper">
    <ProductCarouselContainer>
      <Slider {...settings}>
        {products.map((item, index) => {
          if (item.image.imageFile.file) {
            return (
              <ProductDetail
                item={item}
                key={item.id}
                animate={index === 0}
                productBackgroundImage={(productBackgroundImage && productBackgroundImage.file) ? productBackgroundImage.file.url : null}
              />
            )
          }
        })}
      </Slider>
    </ProductCarouselContainer>
  </Wrapper>
)

ProductCarousel.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    item: PropTypes.shape({
      productImage: PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      productSpecification: PropTypes.shape({
        childMarkdownRemark: PropTypes.shape({
          html: PropTypes.string.isRequired,
        }),
      }).isRequired,
      ctaLink: PropTypes.string,
      ctaLabel: PropTypes.string,
    }).isRequired,
    logos: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  })).isRequired,
  settings: PropTypes.shape({
    dots: PropTypes.bool.isRequired,
    infinite: PropTypes.bool.isRequired,
    speed: PropTypes.number.isRequired,
    slidesToShow: PropTypes.number.isRequired,
    slidesToScroll: PropTypes.number.isRequired,
  }),
  productBackgroundImage: PropTypes.string,
}

ProductCarousel.defaultProps = {
  productBackgroundImage: '',
  settings: {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  },
}

export default ProductCarousel

export const ProductCarouselFragment = graphql`
  fragment ProductCarouselFragment on ContentfulProductCarousel {
    id
    title
    productBackgroundImage {
      file {
        url
      }
    }
    products {
      ...ProductDetailFragment
    }
  }
`
